import { TariffContext } from 'Services/ProductManagement/Features/Tariff/Context/tariffContext'
import { useGetSingleTariffQuery } from 'Services/ProductManagement/Features/Tariff/tariffApi'
import { useContext, useEffect } from 'react'

/**
 * Custom hook to manage and retrieve the selected tariff.
 * This hook takes care of updating the selected tariff in the drawer's dropdown menu.
 */
function useSelectedTariff(id: string | undefined) {
  const { selectedTariffId, setSelectedTariffId } = useContext(TariffContext)
  const {
    data: singleTariff,
    isLoading: isSingleTariffLoading,
    isSuccess
  } = useGetSingleTariffQuery(id || '', {
    skip: !id
  })

  useEffect(() => {
    if (!id || !isSuccess || id === selectedTariffId) return
    // Update the selected tariff in the context
    setSelectedTariffId(id)
  }, [id, isSuccess, setSelectedTariffId])

  return {
    singleTariff,
    isSingleTariffLoading
  }
}

export default useSelectedTariff
